/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Button, Table, Space, Modal, message } from 'antd';
import SPButton from 'components/carRental/base/SPButton';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';
import { getUserList } from '../../../../hooks/carRental/employee';
import { encryptTextByAES, decryptTextByAES } from '../../../../utils/encryption';
import emiter, {
	EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST,
	EVENT_CARRENTAL_EMPLOYEE_ADD,
	EVENT_CARRENTAL_EMPLOYEE_EDIT,
	EVENT_CARRENTAL_EMPLOYEE_VIEW,
	EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL,
} from '../../../../events';
import { changeStatus, deleteUser } from '../../../../hooks/carRental/employee';
import moment from 'moment';
import SPContentWrap from '../../base/SPContentWrap';

interface ActionBarPropsType {
	permission?: any;
}

const SPEmployeeListActionBar: React.FC<ActionBarPropsType> = props => {
	const { permission } = props;

	const createButtonText = '创建员工';
	// const createMoreButtonText = '批量创建员工';
	const actionBarStyle: React.CSSProperties = { padding: 12 };

	const onCreate = () => {
		emiter.emit(EVENT_CARRENTAL_EMPLOYEE_ADD);
	};

	return (
		<SPContentWrap className="page-action-bar">
			<Space>
				<SPButton permissionKey="user_list_add" permission={permission} type="primary" onClick={onCreate}>
					{createButtonText}
				</SPButton>
				{/* <Button type="primary">{createMoreButtonText}</Button> */}
			</Space>
		</SPContentWrap>
	);
};

interface TableStatusPropsType {
	tableData?: any;
}

const SPEmployeeListTableStatus: React.FC<TableStatusPropsType> = props => {
	const { tableData } = props;

	return <div>{tableData === 1 ? '启用' : '禁用'}</div>;
};

interface TableListPropsType {
	tableList?: any;
	type?: any;
}

const SPEmployeeListTableList: React.FC<TableListPropsType> = props => {
	const { tableList, type } = props;
	const list: any = [];
	if (Array.isArray(tableList) && tableList.length) {
		tableList.forEach((item: any) => {
			if (type && type === 'store') {
				list.push(item.store_name);
			} else {
				list.push(item.name);
			}
		});
	}
	return list.length ? list.join(',') : '';
};

interface TableActionBarPropsType {
	data?: any;
	permission?: any;
}

const SPEmployeeListTableActionBar: React.FC<TableActionBarPropsType> = props => {
	const { data, permission } = props;

	const onEdit = () => {
		emiter.emit(EVENT_CARRENTAL_EMPLOYEE_EDIT, data);
	};

	const onView = () => {
		emiter.emit(EVENT_CARRENTAL_EMPLOYEE_VIEW, data);
	};

	// 确认禁用/启用
	const confirmChange = () => {
		changeStatus({
			uid: data.uid,
			user_status: data.user_status === 1 ? 0 : 1,
		}).then((res: any) => {
			if (res.data) {
				message.success('操作成功');
				emiter.emit(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST);
			}
		});
	};

	const changeUserStatus = () => {
		Modal.confirm({
			centered: true,
			title: '确认执行此操作吗',
			okText: '确认',
        	cancelText: '取消',
			onOk: confirmChange,
		});
	};

	// 确认删除
	const confirmDelete = () => {
		deleteUser({
			uid: data.uid,
		}).then((res: any) => {
			if (res.data) {
				message.success('删除成功');
				emiter.emit(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST);
			}
		});
	};

	const onDelete = () => {
		Modal.confirm({
			centered: true,
			title: '确认删除吗',
			okText: '确认',
        	cancelText: '取消',
			onOk: confirmDelete,
		});
	};

	const onCorrelation = () => {
		emiter.emit(EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL, data);
	};

	return data?.is_supplier ? null : (
		<>
			<div>
				<SPButton permissionKey="user_view" permission={permission} type="link" onClick={onView}>
					查看
				</SPButton>
				<SPButton permissionKey="user_edit" permission={permission} type="link" onClick={onEdit}>
					编辑
				</SPButton>
				<SPButton permissionKey="user_status" permission={permission} type="link" onClick={changeUserStatus}>
					{data.user_status === 1 ? '禁用' : '启用'}
				</SPButton>
				<SPButton permissionKey="user_list_del" permission={permission} type="link" onClick={onDelete}>
					删除
				</SPButton>
				<SPButton permissionKey="user_bind_store" permission={permission} type="link" onClick={onCorrelation}>
					关联门店
				</SPButton>
			</div>
		</>
	);
};

interface TableDataType {
	id: number;
	username?: string;
	cell_encrypt?: string;
	user_status?: number;
	role_list?: any;
	store_list?: any;
	create_time?: string;
	update_time?: string;
}

interface TablePropsType {
	enums?: any;
	value?: any;
	actionBar?: any;
	permission?: any;
}

const SPEmployeeListTable: React.FC<TablePropsType> = props => {
	const { permission } = props;
	const columns: TableProps<TableDataType>['columns'] = [
		{
			title: '姓名',
			dataIndex: 'user_name',
			key: 'user_name',
			width: 120,
		},
		{
			title: '手机号',
			dataIndex: 'cell_encrypt',
			key: 'cell_encrypt',
			width: 120,
		},
		{
			title: '状态',
			dataIndex: 'user_status',
			key: 'user_status',
			width: 60,
			render: text => <SPEmployeeListTableStatus tableData={text} />,
		},
		{
			title: '所属角色',
			dataIndex: 'role_list',
			key: 'role_list',
			width: 300,
			render: text => <SPEmployeeListTableList tableList={text} />,
		},
		{
			title: '所属门店',
			dataIndex: 'store_list',
			key: 'store_list',
			width: 200,
			render: text => <SPEmployeeListTableList tableList={text} type="store" />,
		},
		{
			title: '创建时间',
			dataIndex: 'create_time',
			key: 'create_time',
			width: 120,
			render: text => moment(text).format('YYYY-MM-DD HH:mm:ss'),
		},
		{
			title: '最后操作时间',
			dataIndex: 'update_time',
			key: 'update_time',
			width: 120,
			render: text => moment(text).format('YYYY-MM-DD HH:mm:ss'),
		},
		{
			title: '操作',
			key: 'action',
			fixed: 'right',
			// className: 'common-tab-action-bar',
			width: 220,
			render: (_, record) => <SPEmployeeListTableActionBar data={record} permission={permission} />,
		},
	];

	const [data, setData] = useState([]);
	const [searchData, setSearchData] = useState({});
	const [totalCount, setTotalCount] = useState(0);
	const [currentPageData, setCurrentPageData] = useState<any>();

	const loadData = (params?: any) => {
		getUserList({
			...(params || {}),
			cell_encrypt: params && params.cell_encrypt ? encryptTextByAES(params.cell_encrypt) : undefined,
		}).then((res: any) => {
			if (res?.data?.list && res?.data?.list.length) {
				res.data.list.forEach((item: any) => {
					if (item.cell_encrypt) {
						item.cell_encrypt = decryptTextByAES(item.cell_encrypt);
					}
				});
			}
			setData(res.data.list);
			setSearchData(params);
			setTotalCount(res.data.total || 0);
			setCurrentPageData({
				pageIndex: res.data.page || 1,
				pageSize: res.data.page_size || 10,
			});
		});
	};

	const onPagination = (pagination: TablePaginationConfig) => {
		emiter.emit(
			EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST,
			Object.assign(searchData || {}, {
				page: pagination.current,
				page_size: pagination.pageSize,
			})
		);
	};

	useEffect(() => {
		loadData({ page: 1, page_size: 10 });
	}, []);

	useEffect(() => {
		emiter.on(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST, loadData);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST)
		}
	}, []);

	return (
		<>
			<SPEmployeeListActionBar permission={permission} />
			<Table
				size='middle'
				scroll={{ x: '100%' }}
				columns={columns}
				dataSource={data}
				rowKey={cols => cols.id}
				pagination={{
					total: totalCount,
					showSizeChanger: true,
					showQuickJumper: true,
					showTotal: total => `共 ${total} 条数据`,
					current: currentPageData?.pageIndex,
					pageSize: currentPageData?.pageSize,
				}}
				onChange={onPagination}
			/>
		</>
	);
};

export default SPEmployeeListTable;
